import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NJDocData, NJDocDefTemplate, DOData, componentVM } from '../DOData';
import { faTrashAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Event } from '@angular/router';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
  selector: 'cylib-dolink',
  templateUrl: './dolink.component.html',
  styleUrls: ['./dolink.component.css']
})
export class DolinkComponent implements OnInit {

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() customParameters: any
    @Input() DocData: NJDocData;
    @Input() isEnabled: boolean;

    linkIcon = faTrashAlt;
    linkClass: string;
    stylesLink: any
    URL:string

    @Output() clickLink: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> = new EventEmitter<componentVM>();
    elemOnBlurGoto: any

    constructor(private data: DocDefPrimLibService) { }

    ngOnInit() {
        if (this.customParameters['StylesLink'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesLink'], "'", '"');
            this.stylesLink = JSON.parse(styles);
        }
        this.URL = this.customParameters['URL']
        this.linkClass = this.customParameters['LinkClass']
        switch (this.customParameters['LinkIcon']) {
            case 'faTrashAlt':
                this.linkIcon = faTrashAlt;
                break;
            case 'faTrash':
                this.linkIcon = faTrash
                break;
            default:
                this.linkIcon = undefined;
                break;
        }
        if (this.customParameters['Tab']) {
            let message: componentVM = new componentVM();
            message.thisComponent = this;
            message.tag = this.customParameters['Tab']
            this.tabEvent.emit(message);
        }
    }
    setOnBlurGoto(element: any) {
        this.elemOnBlurGoto = element;
    }
    onBlurLink(event: any) {
        if (this.elemOnBlurGoto) {
            //event.stopPropagation();
            event.preventDefault();
            event.stopImmediatePropagation();
            this.elemOnBlurGoto.setFocus();
            return false;
        }
    }
    onDoLinkClick() {
        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = this.DocData;
        DOMessage.njDocDefTemplate = this.DocDefTemplate;
        this.clickLink.emit(DOMessage);
    }

}
